import { render } from "./Video.vue?vue&type=template&id=c0ad7096&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=c0ad7096&scoped=true&lang=css"

import exportComponent from "/home/roland/coding/Kitchen101/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ad7096"]])

export default __exports__